import { H6 } from "../../../../../../../AbstractElements";
import { Categories, NewProducts, Price } from "../../../../../../../Constants/Constants";
import GenderFilter from "./GenderFilter";
import BrandFilter from "./BrandFilter";
import ColorsFilter from "./ColorsFilter";
import RangeSlider from "./RangeSlider";

export const Category = () => {
  return (
    <>
      <div className="product-filter">
        <H6 className="f-w-600">{Categories}</H6>
        <GenderFilter />
      </div>
      <BrandFilter />
      <ColorsFilter />
      <div className="product-filter pb-0 price-range">
        <H6 className="f-w-600">{Price}</H6>
        <RangeSlider />
        <H6 className="f-w-600 mb-2 mt-5">{NewProducts}</H6>
      </div>
    </>
  );
};
